import React, { useEffect, useState } from "react";
import { Col, Row, Select, Spin } from "antd";
import { Controller } from "react-hook-form";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { fetchClass, fetchSections } from "../../../../../../services/student";

const StudentLevelClass = ({ control, watch }) => {
  const [loading, setLoading] = useState(false);
  const [studentLevel, setStudentLevel] = useState([]);
  const [sections, setSections] = useState([]);

  const createSelection = (data = []) =>
    data?.map((item) => ({
      label: item?.name,
      value: item.id,
    }));

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await fetchClass();
        const classData = createSelection(response?.data?.data?.levels ?? []);
        setStudentLevel(classData);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const isClassSelected = watch("level_id");

  useEffect(() => {
    if (isClassSelected) {
      (async () => {
        try {
          setLoading(true);
          const resp = await fetchSections(isClassSelected);
          const sectionData = createSelection(
            resp?.data?.data?.classrooms ?? []
          );
          setSections(sectionData);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [isClassSelected]);

  return (
    <Spin spinning={loading}>
      <Row gutter={[32, 20]}>
        <Col span={12}>
          <Controller
            name="level_id"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="level_id"
                label="Select Level"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {studentLevel?.map((item, index) => (
                  <Select.Option key={index} value={item?.value}>
                    {item?.label}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>

        <Col span={12}>
          <Controller
            name="classroom_id"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="classroom_id"
                label="Select Class"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {sections?.map((item, index) => (
                  <Select.Option key={index} value={item?.value}>
                    {item?.label}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default StudentLevelClass;
